exports = module.exports = require("../../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title {\n  text-align: center;\n}\n.brief {\n  width: 430px;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 auto;\n  word-wrap: break-word;\n}\n.brief .address {\n  margin-right: 190px;\n}\n.brief img {\n  width: 14px;\n  margin-right: 10px;\n  vertical-align: top;\n}\n.brief div {\n  margin-bottom: 19px;\n  color: #9e9e9e;\n  line-height: 1;\n}\n.brief .small-title {\n  font-size: 16px;\n  color: #343434;\n  margin-bottom: 28px;\n}\n.brief .author span {\n  display: inline-block;\n  width: 380px;\n  line-height: 1.57;\n}\n.detail .top {\n  float: left;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/apple/Documents/object/chinaicac-portal/src/app/events/detail-workshop/detail-workshop.component.styl
// module id = ../../../../../src/app/events/detail-workshop/detail-workshop.component.styl
// module chunks = main